import { http } from 'http';

export default {
  createOperation: params => http.post('/bconnect/operations', params),

  appliedConsents: (guid, params) => http.post(`/webh/appliedconsents?id=${guid}`, params),

  updateSign: params => http.post('/bconnect/sign', params),

  stepManager: guid => http.post(`/bconnect/stepManager/${guid}`),

  electronicSignature: params => http.post('/bconnect/electronicsignature', params),

  registerSignature: params => http.post('/bconnect/registersignature', params),

  uploadStudyDocumentation: guid => http.post(`/bconnect/uploadstudydocumentation/${guid}`)
};
